import { createBusinessComponent } from '../utils/create';
import '@tujia/fe-lib-common/lib/third-libs/date-helper.js';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_c('div', {
      staticClass: "g-layout-month"
    }, [_c('div', {
      staticClass: "u-month-text"
    }, [_vm._v("\n      " + _vm._s(_vm.year + '年' + (_vm.month + 1) + '月') + "\n    ")]), _c('div', {
      staticClass: "calendar-month-content tj-clearfix",
      class: {
        'is-custom-style': _vm.isCustomStyle
      }
    }, [_vm._l(_vm.dayList, function (day, index) {
      return _c('tjb-calendar-day', {
        key: String(index) + day.date,
        staticClass: "month-calendar-day",
        class: {
          'month-calendar-day-price': _vm.isPriceCalendar
        },
        attrs: {
          "day": day,
          "is-price-calendar": _vm.isPriceCalendar,
          "date-text": _vm.dateText,
          "is-show-yesterday-tip": _vm.isShowYesterdayTip,
          "is-custom-style": _vm.isCustomStyle,
          "holiday-data": _vm.holidayData,
          "is-show-holiday": _vm.isShowHoliday
        },
        on: {
          "click": _vm.dayClick
        }
      });
    }), _vm.isCustomStyle ? _c('div', {
      staticClass: "bgNum"
    }, [_vm._v(_vm._s(_vm.month + 1))]) : _vm._e()], 2)])]);
  },
  name: 'calendar-month',
  props: ['year', 'month', 'days', 'isPriceCalendar', 'dateText', 'isOpenYesterday', 'yesterdayTip', 'isShowYesterdayTip', 'isCustomStyle', 'isShowHoliday', 'holidayData'],
  data: function data() {
    return {
      dayList: []
    };
  },
  created: function created() {
    this.initDays();
  },
  watch: {
    days: function days() {
      this.initDays();
    }
  },
  methods: {
    dayClick: function dayClick(day) {
      // 日期可能不存在，代表空位补
      if (day.date && (!day.isUnActiveDay && !day.isBlankSpace || day.isShortCustom)) {
        this.$emit('daySelected', day);
      }
    },
    initDays: function initDays() {
      var _this = this;

      this.dayList = []; // 每次获取新数据之后，都得清空dataList

      if (this.days && this.days.length > 0) {
        // 这里是设置无效日期的地方 如果有 isOpenYesterday 配置说明可以选昨天
        var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        var cloneToday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

        if (this.isOpenYesterday) {
          today.addDays(-1);
          cloneToday.addDays(-1);
        } // 大于180天的日期不能选择


        cloneToday.addDays(180);
        this.days.map(function (i) {
          // 如果小于当前日期，则日期设置为无效
          var dateCompare = i.date.compareTo(today);

          if (dateCompare === 0) {
            // eslint-disable-next-line no-self-assign
            i.isUnActiveDay = i.isUnActiveDay;
          } else {
            i.isUnActiveDay = dateCompare === -1;
          } // 如果大于今天加180天， 则日期设置无效


          if (i.date.compareTo(cloneToday) === 1) {
            i.isUnActiveDay = true;
          } // 如果配置昨天可选 并且当前日期是昨天的话 给一个记录


          if (_this.isOpenYesterday && today.equals(i.date)) {
            i.isYesterday = true;
            i.yesterdayTip = _this.yesterdayTip;
          }

          _this.dayList.push(i);
        }); // 自动补空位

        var weekPushCount = 7 - this.days[this.days.length - 1].date.getDay() - 1;
        var weekUnShiftCount = this.days[0].date.getDay();

        for (var j = 0; j < weekPushCount; j++) {
          this.dayList.push({
            isBlankSpace: true
          });
        }

        for (var k = 0; k < weekUnShiftCount; k++) {
          this.dayList.unshift({
            isBlankSpace: true
          });
        }
      }
    }
  }
});